<div id="action-cell-icons" *ngIf="!isEditable()" class="action-cell-margin-cell">
    <span class="clickable" id="editRowIcon" (click)="editRow()" [ngClass]="{'disable-icon': disableEditIcon}">
        <svg class="icon-16">
            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
        </svg>
    </span>
    <div class="action-icons-separator"></div>
    <span class="clickable" id="deleteRowIcon" (click)="deleteRow()">
        <svg class="icon-16">
            <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
        </svg>
    </span>
</div>

<div *ngIf="isEditable()" class="action-buttons">
    <button id="fieldCancelBtn" class="cxone-btn btn-big btn-secondary btn-bg-is-white" (click)="cancelRowEditing()"
        cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Cancel">Cancel</button>
    <div class="action-buttons-separator"></div>
    <button id="fieldSaveBtn" class="cxone-btn btn-big btn-primary btn-bg-is-white" (click)="saveRowData()"
        [disabled]="!isValidData" cvLocalizedText langSection="ETL_Data_Feed_Create" langKey="Save_Button">Save</button>
</div>